import { create } from 'zustand';
import { DEFAULT_TIME_RANGE, resolveStoredTimeRange } from './initial-time-range';

interface CompanyStore {
  companyName: string | undefined;
  setCompanyName: (name: string | undefined) => void;
}

export const useCompanyStore = create<CompanyStore>((set) => ({
  companyName: localStorage.getItem('selectedCompany') || undefined,
  setCompanyName: (name: string | undefined) => {
    if (name) {
      localStorage.setItem('selectedCompany', name);
    } else {
      localStorage.removeItem('selectedCompany');
    }
    set({ companyName: name });
  },
}));

interface TimeRangeStore {
  timeRange: string | undefined;
  startTime: string | undefined;
  endTime: string | undefined;
  setTimeRangeFilter: (timeRange: string | undefined, startTime?: string, endTime?: string) => void;
}

export const useTimeRangeStore = create<TimeRangeStore>((set) => {
  const initial = resolveStoredTimeRange(window.location.search, localStorage);

  return {
    timeRange: initial.timeRange,
    startTime: initial.startTime,
    endTime: initial.endTime,
    setTimeRangeFilter: (timeRange, startTime, endTime) => {
      if (timeRange) {
        localStorage.setItem('selectedTimeRange', timeRange);
        localStorage.removeItem('selectedStartTime');
        localStorage.removeItem('selectedEndTime');
        set({ timeRange, startTime: undefined, endTime: undefined });
      } else if (startTime && endTime) {
        localStorage.removeItem('selectedTimeRange');
        localStorage.setItem('selectedStartTime', startTime);
        localStorage.setItem('selectedEndTime', endTime);
        set({ timeRange: undefined, startTime, endTime });
      } else {
        // The range picker clears itself by sending empty strings. Storing those would
        // leave every query with no window at all, and it would stick across pages.
        localStorage.setItem('selectedTimeRange', DEFAULT_TIME_RANGE);
        localStorage.removeItem('selectedStartTime');
        localStorage.removeItem('selectedEndTime');
        set({ timeRange: DEFAULT_TIME_RANGE, startTime: undefined, endTime: undefined });
      }
    },
  };
});
